// Objetivo: Definir os tipos de chaves pix
export const PixKey = {
  CPF: 'C',
  CNPJ: 'J',
  PHONE: 'T',
  EMAIL: 'E',
  RANDOM: 'A',
};
